import type { EmbedMode } from './UseHestiaIframe'

export const HESTIA_TO_PARENT_RELAY_REQUEST = 'HESTIA_TO_PARENT_RELAY_REQUEST'
export const HESTIA_PHONE_ORDERING_ROUTE_SYNC =
  'HESTIA_PHONE_ORDERING_ROUTE_SYNC'
export const HESTIA_PRINT_SHOP_ROUTE_SYNC = 'HESTIA_PRINT_SHOP_ROUTE_SYNC'
export const PARENT_TO_HESTIA_EVENT = 'PARENT_TO_HESTIA_EVENT'

export enum HestiaIframeTarget {
  OwnerAgentWidget = 'owner-agent-widget',
  WebsiteBuilder = 'website-builder-hermes',
}

export enum HestiaIframeEvent {
  WebsitePreviewReload = 'website-preview.reload',
}

export interface HestiaToParentRelayRequest {
  event: HestiaIframeEvent
  target: HestiaIframeTarget
  type: typeof HESTIA_TO_PARENT_RELAY_REQUEST
}

export interface HestiaPhoneOrderingRouteSyncMessage {
  callId: string | null
  type: typeof HESTIA_PHONE_ORDERING_ROUTE_SYNC
}

export interface HestiaPrintShopRouteSyncMessage {
  orderId: string | null
  type: typeof HESTIA_PRINT_SHOP_ROUTE_SYNC
}

export interface ParentToHestiaEvent {
  event: HestiaIframeEvent
  source: HestiaIframeTarget
  type: typeof PARENT_TO_HESTIA_EVENT
}

interface BuildParentToHestiaEventParams {
  event: HestiaIframeEvent
  source: HestiaIframeTarget
}

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return Boolean(value) && typeof value === 'object'
}

export const isHestiaIframeTarget = (
  value: unknown
): value is HestiaIframeTarget => {
  return Object.values(HestiaIframeTarget).includes(value as HestiaIframeTarget)
}

export const isHestiaIframeEvent = (
  value: unknown
): value is HestiaIframeEvent => {
  return Object.values(HestiaIframeEvent).includes(value as HestiaIframeEvent)
}

export const normalizeEmbedToHestiaIframeTarget = (
  embed: EmbedMode | null | undefined
): HestiaIframeTarget | null => {
  switch (embed) {
    case 'owner-agent-widget':
      return HestiaIframeTarget.OwnerAgentWidget
    case 'website-builder-hermes':
      return HestiaIframeTarget.WebsiteBuilder
    default:
      return null
  }
}

export const buildParentToHestiaEvent = ({
  event,
  source,
}: BuildParentToHestiaEventParams): ParentToHestiaEvent => {
  return {
    event,
    source,
    type: PARENT_TO_HESTIA_EVENT,
  }
}

export const isHestiaToParentRelayRequest = (
  value: unknown
): value is HestiaToParentRelayRequest => {
  if (!isRecord(value)) return false

  return (
    value.type === HESTIA_TO_PARENT_RELAY_REQUEST &&
    isHestiaIframeTarget(value.target) &&
    isHestiaIframeEvent(value.event)
  )
}

export const isHestiaPhoneOrderingRouteSyncMessage = (
  value: unknown
): value is HestiaPhoneOrderingRouteSyncMessage => {
  if (!isRecord(value)) return false

  return (
    value.type === HESTIA_PHONE_ORDERING_ROUTE_SYNC &&
    (typeof value.callId === 'string' || value.callId === null)
  )
}

export const isHestiaPrintShopRouteSyncMessage = (
  value: unknown
): value is HestiaPrintShopRouteSyncMessage => {
  if (!isRecord(value)) return false

  return (
    value.type === HESTIA_PRINT_SHOP_ROUTE_SYNC &&
    (typeof value.orderId === 'string' || value.orderId === null)
  )
}
